(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var sections = document.querySelectorAll('.ba-category-tiles');
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    sections.forEach(function (section) {
      section.classList.add('ba-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-inview');
            io.disconnect();
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
      io.observe(section);
    });
  }

  /* Birthstone clock. Each tile is a clock face: the cursor's angle from the
     tile centre picks one of twelve 30-degree sectors, hour N = month N, so
     3 o'clock is March. Hovering swaps to that month's stone in that tile's
     own category. Pointer-driven, so touch devices never enter it. */
  function clock() {
    var host = document.querySelector('[data-ba-clock-data]');
    if (!host) return;
    var table;
    try { table = JSON.parse(host.textContent); } catch (e) { return; }

    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    document.querySelectorAll('.ba-category-tile[data-clock]').forEach(function (tile) {
      var own = {};
      try { own = JSON.parse(tile.getAttribute('data-clock-own') || '{}'); } catch (e) {}
      var base = table[tile.getAttribute('data-clock')] || {};
      var set = {};
      Object.keys(base).forEach(function (m) { set[m] = base[m]; });
      /* A theme-editor image replaces the photo; the caption keeps the table's stone
         when there is one, otherwise shows the month alone. */
      Object.keys(own).forEach(function (m) {
        set[m] = { url: own[m].url, month: MONTHS[parseInt(m, 10) - 1], stone: base[m] ? base[m].stone : '' };
      });
      if (!Object.keys(set).length) return;
      var a = tile.querySelector('.ba-category-tile__img--a');
      var b = tile.querySelector('.ba-category-tile__img--b');
      var stone = tile.querySelector('.ba-category-tile__stone');
      var ticksBox = tile.querySelector('.ba-category-tile__ticks');
      if (!a || !b || !ticksBox) return;

      var width = tile.getAttribute('data-width') || 900;
      var resting = a.getAttribute('src');
      var front = a, back = b, current = null, warmed = false;
      var ticks = [];

      for (var h = 1; h <= 12; h++) {
        var t = document.createElement('i');
        t.className = 'ba-category-tile__tick';
        ticksBox.appendChild(t);
        ticks.push(t);
      }
      function placeTicks() {
        var r = tile.getBoundingClientRect();
        var rx = r.width / 2 - 14, ry = r.height / 2 - 14;
        ticks.forEach(function (t, i) {
          var deg = (i + 1) * 30, rad = deg * Math.PI / 180;
          t.style.transform = 'translate(-50%, -50%) translate(' +
            (Math.sin(rad) * rx) + 'px, ' + (-Math.cos(rad) * ry) + 'px) rotate(' + deg + 'deg)';
        });
      }
      placeTicks();
      window.addEventListener('resize', placeTicks);

      /* Latest-wins guard: rapid pointer moves fire several image loads at once.
         Only the newest request may paint, and its caption must land in the SAME
         frame as its photo — otherwise the tile can flash one stone's name over
         another stone's picture (e.g. "January" over the resting Peridot). */
      var reqId = 0;
      function to(src, caption) {
        var id = ++reqId;
        back.onload = null;
        // The resting <img> ships a responsive srcset pointing at the resting
        // stone. srcset wins over .src, so without stripping it the browser
        // repaints the RESTING image (Peridot) instead of the one we set here —
        // making every other crossfade fall back to Peridot. Load an exact src.
        back.removeAttribute('srcset');
        back.removeAttribute('sizes');
        back.src = src;
        function paint() {
          if (id !== reqId) return;              /* superseded by a newer request */
          back.style.opacity = 1;
          front.style.opacity = 0;
          var tmp = front; front = back; back = tmp;
          stone.textContent = caption || '';     /* photo + label swap together */
        }
        if (back.complete) paint(); else back.onload = paint;
      }
      function show(month) {
        if (month === current) return;
        current = month;
        var entry = set[month];
        if (!entry) {
          /* No piece in this category for that stone. Fall back to the resting
             image and drop the caption rather than mislabel the wrong stone. */
          if (resting) to(resting, '');
          return;
        }
        // Designer tiles carry a blank stone, so the caption drops to the month
        // alone rather than claiming a birthstone the piece may not be.
        var cap = entry.stone ? (entry.month + ' — ' + entry.stone) : entry.month;
        to(entry.url + '?width=' + width, cap);
      }

      tile.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        tile.classList.add('is-live');
        placeTicks();
        if (!warmed) {
          warmed = true;
          Object.keys(set).forEach(function (m) {
            var im = new Image();
            im.src = set[m].url + '?width=' + width;
          });
        }
      });
      tile.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = tile.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        var deg = Math.atan2(dx, -dy) * 180 / Math.PI;   /* 0 = straight up = 12 o'clock */
        if (deg < 0) deg += 360;
        var hour = Math.round(deg / 30);
        if (hour === 0) hour = 12;
        ticks.forEach(function (t, i) { t.classList.toggle('is-on', i + 1 === hour); });
        show(hour < 10 ? '0' + hour : '' + hour);
      });
      tile.addEventListener('pointerleave', function () {
        tile.classList.remove('is-live');
        ticks.forEach(function (t) { t.classList.remove('is-on'); });
        current = null;
        stone.textContent = '';
        if (resting) to(resting, '');
      });
    });
  }

  function boot() { init(); clock(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.querySelector('.ba-header');
  if (!header) return;
  var inner = header.querySelector('.ba-header__inner');
  var wordmark = header.querySelector('.ba-header__wordmark');
  var rail = header.querySelector('.ba-header__nav-wrap');
  if (!inner || !wordmark) return;

  function measure() {
    var shift = inner.clientWidth / 2 - (wordmark.offsetLeft + wordmark.offsetWidth / 2);
    header.style.setProperty('--wordmark-shift', shift + 'px');
  }

  /* The phone rail hides its scrollbar, so the edge fades are the only cue
     that it moves. No-ops on desktop, where the nav never overflows. */
  function railEdges() {
    if (!rail) return;
    var slack = rail.scrollWidth - rail.clientWidth;
    if (slack < 8) {
      rail.removeAttribute('data-overflow');
    } else if (rail.scrollLeft <= 4) {
      rail.setAttribute('data-overflow', 'end');
    } else if (rail.scrollLeft >= slack - 4) {
      rail.setAttribute('data-overflow', 'start');
    } else {
      rail.setAttribute('data-overflow', 'both');
    }
  }

  /* The fade alone is easy to miss, so on the first page of a visit the rail
     glides a short way left and back — enough to show it moves. Once per
     session, never with reduced motion, and only when it starts at the left. */
  function railHint() {
    if (!rail || rail.getAttribute('data-overflow') !== 'end') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try { if (sessionStorage.getItem('ba-rail-hint')) return; sessionStorage.setItem('ba-rail-hint', '1'); } catch (e) {}
    setTimeout(function () {
      rail.scrollTo({ left: 72, behavior: 'smooth' });
      setTimeout(function () { rail.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
    }, 900);
  }

  /* Open with the page you are on in view: on a collection the rail otherwise
     starts at PENDANTS with the active title stranded two swipes right.
     scrollLeft rather than scrollIntoView, which would drag the page down. */
  function railCentre() {
    if (!rail) return;
    var current = rail.querySelector('a[aria-current="page"]');
    if (!current) return;
    var railBox = rail.getBoundingClientRect();
    var linkBox = current.getBoundingClientRect();
    rail.scrollLeft += linkBox.left - railBox.left - (railBox.width - linkBox.width) / 2;
  }

  /* Direction has to be held for TRAVEL px before the header changes state,
     and nothing toggles again until the glide has finished (LOCK ms). Without
     both, small scroll jitters — or the phone rail collapsing and nudging the
     scroll position — flip it to the centre and back mid-animation. */
  var TOP_ZONE = 80;
  var TRAVEL = 28;
  var LOCK = 850;
  var lastY = window.scrollY;
  var travelled = 0;
  var lockedUntil = 0;
  var ticking = false;

  function setCondensed(on) {
    if (header.classList.contains('ba-header--condensed') === on) return;
    if (on) measure();
    header.classList.toggle('ba-header--condensed', on);
    lockedUntil = Date.now() + LOCK;
    travelled = 0;
  }

  function update() {
    ticking = false;
    var y = window.scrollY;
    var dy = y - lastY;
    lastY = y;
    if (y <= TOP_ZONE) { setCondensed(false); return; }
    if (Date.now() < lockedUntil) return;
    if (dy === 0) return;
    travelled = (travelled > 0) === (dy > 0) ? travelled + dy : dy;
    if (travelled > TRAVEL) setCondensed(true);
    else if (travelled < -TRAVEL) setCondensed(false);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  measure();
  /* The serif wordmark changes width when the web font swaps in; measure again
     so the glide lands dead centre instead of correcting with a snap. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  window.addEventListener('load', measure);
  railCentre();
  railEdges();
  railHint();
  if (rail) rail.addEventListener('scroll', railEdges, { passive: true });
  window.addEventListener('resize', function () {
    measure();
    railEdges();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
(function () {
  var input = document.querySelector('[data-stone-search]');
  if (!input) return;
  var root = input.closest('.ba-list-collections');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('.ba-list-collections__tile'));
  var empty = root.querySelector('[data-stone-search-empty]');
  input.addEventListener('input', function () {
    var q = input.value.trim().toLowerCase();
    var shown = 0;
    tiles.forEach(function (tile) {
      var label = tile.querySelector('.ba-list-collections__label');
      var name = label ? label.textContent.trim().toLowerCase() : '';
      var match = !q || name.indexOf(q) !== -1;
      tile.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    if (empty) empty.hidden = shown > 0;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
